const steps = [
  {
    number: '01',
    title: '深層診斷',
    description: '了解企業現況、營運痛點與升級需求，初步評估適合的資源方向。',
  },
  {
    number: '02',
    title: '策略共創',
    description: '結合產業特性、財務條件與經營目標，規劃可執行的升級方案。',
  },
  {
    number: '03',
    title: '計畫撰擬',
    description: '協助整理企業亮點、服務價值與執行內容，讓計畫內容更清楚完整。',
  },
  {
    number: '04',
    title: '審查陪跑',
    description: '協助準備簡報、補件資料與溝通重點，提升專案推動效率。',
  },
  {
    number: '05',
    title: '驗收核銷',
    description: '協助整理執行成果、核銷資料與結案流程，降低企業行政負擔。',
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-primary-900 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-4 leading-tight">
            服務流程：與您並肩前行
          </h2>
          <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto leading-relaxed">
            從診斷到落地，每一步都有專業顧問陪伴，讓企業升級更順暢、更有方向。
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          {/* 5 張卡片統一排成一排 */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className="relative bg-primary-800 rounded-xl p-6 border border-primary-700 hover:border-accent-500/60 transition-colors duration-300 flex flex-col"
              >
                {/* 數字：大且醒目，金色 */}
                <span className="text-4xl md:text-5xl font-black text-accent-500 leading-none mb-4">
                  {step.number}
                </span>

                {/* 標題：白色粗體 */}
                <h3 className="text-lg md:text-xl font-bold text-white mb-3 leading-tight">
                  {step.title}
                </h3>

                {/* 內文：白色 90% 亮度，清晰可讀 */}
                <p className="text-sm text-white/90 leading-relaxed flex-grow">
                  {step.description}
                </p>

                {/* 箭頭連接線（桌機版） */}
                {index < 4 && (
                  <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 z-10 items-center justify-center">
                    <div className="w-6 h-6 rounded-full bg-accent-500 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-primary-900 text-xs" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* 底部裝飾線 */}
          <div className="hidden lg:block mt-10">
            <div className="flex items-center justify-center">
              <div className="h-px w-32 bg-accent-500/40" />
              <div className="w-2 h-2 rounded-full bg-accent-500 mx-3" />
              <div className="h-px w-32 bg-accent-500/40" />
              <div className="w-2 h-2 rounded-full bg-accent-500 mx-3" />
              <div className="h-px w-32 bg-accent-500/40" />
            </div>
            <p className="text-center text-sm text-white/60 mt-4">
              完整顧問流程，從頭到尾全程陪伴
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}